module.exports = __webpack_public_path__ + "img/languages.cc953951.png";